import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import parent from '@/api/parent';

const { getParentMe } = parent();

function isParentAccount(user, accountType) {
	if (accountType === 'parent') return true;
	if (accountType === 'legacy') return false;
	if (user?.customer) return false;
	const groups = user?.groups || [];
	return groups.some((g) => g?.name === 'Parent PoS');
}

export default function AuthProvider({ children }) {
	const dispatch = useDispatch();
	const key = useSelector((state) => state.auth.key);
	const user = useSelector((state) => state.auth.user);
	const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
	const accountType = useSelector((state) => state.auth.accountType);
	const childrenLoaded = useSelector((state) => state.auth.childrenLoaded);
	const meRequested = useRef(false);

	useEffect(() => {
		if (!isAuthenticated && key && user) {
			dispatch({ type: 'auth/setAuthenticated' });
		}
	}, [isAuthenticated, key, user, dispatch]);

	// Reload children from me/ — persisted children are not the source of truth.
	useEffect(() => {
		if (!isAuthenticated || !key || !user) return;
		if (!isParentAccount(user, accountType)) {
			if (!childrenLoaded && user.customer) {
				dispatch({
					type: 'auth/setParentMe',
					payload: {
						account_type: 'legacy',
						children: [user.customer],
						outlet: user.customer.outlet,
					},
				});
			}
			return;
		}
		if (meRequested.current) return;
		meRequested.current = true;

		getParentMe({ token: key })
			.then((res) => {
				dispatch({ type: 'auth/setParentMe', payload: res.data });
				const kids = res.data?.children || [];
				const allowedIds = kids
					.filter((c) => c && c.is_active !== false && c.family_is_active !== false)
					.map((c) => c.id);
				dispatch({ type: 'cart/pruneInvalidOwners', payload: { allowedIds } });
			})
			.catch(() => {
				// Keep session; mark loaded so empty state can show
				dispatch({
					type: 'auth/setParentMe',
					payload: {
						account_type: 'parent',
						children: [],
						outlet: null,
					},
				});
				dispatch({ type: 'cart/pruneInvalidOwners', payload: { allowedIds: [] } });
			});
	}, [isAuthenticated, key, user, accountType, childrenLoaded, dispatch]);

	useEffect(() => {
		if (!isAuthenticated) {
			meRequested.current = false;
		}
	}, [isAuthenticated]);

	return children;
}
